var map = {
	"./dscecoimbatore.jpg": 4804,
	"./dscecoimbatore_logo.jpg": 4328,
	"./dscecoimbatore_youtube_preview.webp": 9433,
	"./hitschennai.jpg": 1456,
	"./hitschennai_logo.png": 9664,
	"./hitschennai_youtube_preview.webp": 7,
	"./m5.jpg": 4822,
	"./m6.jpg": 4433,
	"./mentor.jpg": 4443,
	"./mentor.png": 8419,
	"./sathyabama.png": 2099,
	"./sathyabama_logo.jpg": 4829,
	"./sathyabama_youtube_preview.webp": 2684,
	"./srmchennai.png": 304,
	"./srmchennai_logo.webp": 110,
	"./srmchennai_youtube_preview.webp": 8873,
	"./vitchennai.jpg": 9487,
	"./vitchennai_logo.jpg": 1281,
	"./vitchennai_youtube_preview.webp": 7832
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8056;